var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/IssueComment.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { IssueCommentType } from './IssueCommentType.enum';
import { IssueAnswer } from './IssueAnswer';
import { createPredicate } from './createPredicate';
import { ApiDomain } from './domain';
import { PaginatedList } from './PaginatedList';
export var IssueComment;
(function (_IssueComment) {
  var domain = ApiDomain.domain('IssueComment', {
    name: "domain",
    sid: "goiwmz"
  });
  var ItemCommon = _IssueComment.ItemCommon = t.type({
    id: t.number,
    createdAt: t.string,
    deleted: t["boolean"],
    text: t.string,
    authorId: t.string,
    issueId: t.number,
    issueVersion: t.number
  });
  var CommentItem = _IssueComment.CommentItem = t.intersection([ItemCommon, t.type({
    type: t.literal(IssueCommentType.ISSUE_COMMENT)
  })]);
  var ChangeAnswerItem = _IssueComment.ChangeAnswerItem = t.intersection([ItemCommon, t.type({
    type: t.literal(IssueCommentType.CHANGE_ANSWER),
    status: IssueAnswer.Status
  })]);
  var isIssueComment = _IssueComment.isIssueComment = createPredicate(IssueCommentType.ISSUE_COMMENT);
  var isChangeAnswer = _IssueComment.isChangeAnswer = createPredicate(IssueCommentType.CHANGE_ANSWER);
  var Item = _IssueComment.Item = t.union([CommentItem, ChangeAnswerItem]);
  var FetchListData = _IssueComment.FetchListData = PaginatedList(Item);
  var fetchList = _IssueComment.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: FetchListData,
    getKey: ['issueId', 'limit', 'offset']
  });
  var create = _IssueComment.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: CommentItem,
    getKey: ['text', 'issueId']
  });
  var remove = _IssueComment.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: CommentItem,
    getKey: ['commentId', 'issueId']
  });
})(IssueComment || (IssueComment = {}));